import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * The body of the "no models available" popover. The trigger and the floating
 * container belong to `ModelsDropdown`; this is only what sits inside.
 */
export const NoModelsPanel = () => {
  const { t } = useTranslation('chats');

  return (
    <div>
      <div className="px-4 pt-2 pb-1">
        <p className="text-base font-normal leading-6 text-muted-foreground">
          {t('chats.noModelsPanel.aiModels')}
        </p>
      </div>

      <div className="flex flex-col items-center gap-2 px-6 pt-4 pb-8 text-center">
        <div className="mb-2 flex size-12 items-center justify-center rounded-full bg-warning">
          <InfoIcon aria-hidden className="size-6 text-warning-foreground" />
        </div>

        <p className="text-base font-medium leading-6 text-foreground">
          {t('chats.noModelsPanel.noAiModelsAvailable')}
        </p>

        <p className="text-sm leading-5 text-muted-foreground">
          {t('chats.noModelsPanel.contactYourOrganizationAdminTo')}
        </p>
      </div>
    </div>
  );
};
